import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useGlobalContext } from "../../ContextApi/GlobalContext";
import { getRouteLinkIndexAdmin } from "../../Functions/RouterFunction";

const MobileTopBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, dispatch } = useGlobalContext();

  useEffect(() => {
    const route = getRouteLinkIndexAdmin();
    if (route?.title && route.title !== state.pageName) {
      dispatch({ pageName: route.title, pageLink: route.link });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const user = state.companyData || {};
  const userName = user.name || "Admin";
  const userInitial = userName.charAt(0).toUpperCase();
  const profilePicURL = user.profilePicURL;

  return (
    <header
      className="fixed top-0 inset-x-0 z-[900] lg:hidden bg-[#0B1C2D]/95 backdrop-blur-xl border-b border-white/10"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="h-14 px-3 flex items-center justify-between gap-3">
        <button
          type="button"
          aria-label="Open menu"
          onClick={() => dispatch({ sideBar: true })}
          className="size-10 flex items-center justify-center rounded-xl text-white/90 active:bg-white/10 transition-colors"
        >
          <span className="material-symbols-outlined text-[24px]">menu</span>
        </button>

        <div className="flex-1 min-w-0 text-center">
          <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-white/40 leading-none mb-0.5">
            ContactHQ
          </p>
          <h1 className="text-sm font-bold text-white truncate tracking-tight">
            {state.pageName || "Dashboard"}
          </h1>
        </div>

        <button
          type="button"
          aria-label="My profile"
          onClick={() => {
            dispatch({ pageLink: "/myprofile", pageName: "My Profile" });
            navigate("/myprofile");
          }}
          className="size-9 rounded-full bg-gradient-to-tr from-blue-500 to-cyan-400 flex items-center justify-center text-white text-xs font-bold overflow-hidden ring-2 ring-white/10 active:scale-95 transition-transform"
        >
          {profilePicURL ? (
            <img
              src={profilePicURL}
              alt=""
              className="w-full h-full object-cover"
            />
          ) : (
            userInitial
          )}
        </button>
      </div>
    </header>
  );
};

export default MobileTopBar;
